import { CheckboxIcon } from '@ardoq/icons';
import { CommonCheckboxProps } from './types';

export const FocusableCheckboxIcon = ({
  isChecked,
  isMixed,
  isFocused,
}: CommonCheckboxProps) => (
  <CheckboxIcon mixed={isMixed} checked={isChecked} isFocused={isFocused} />
);
